import { Component } from "react";
import PropTypes from "prop-types";
import constants from "../../utils/constants";
import { requestRecoverReservation } from "../../utils/witbookingApi";
import { withRouter } from "react-router";
import { parse as queryStringParse } from "query-string";

class RecoverReservation extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.reservationId) {
      const locale = this.props.match.params.locale ? `/${this.props.match.params.locale}` : "";
      const queryParams =
        (this.props.location &&
          this.props.location.search &&
          queryStringParse(this.props.location.search)) ||
        {};
      const email = queryParams && queryParams.email;
      const query = this.props.location && this.props.location.search;

      requestRecoverReservation(
        {},
        {
          reservationId: this.props.match.params.reservationId,
          email,
        }
      )
        .then(reservation => {
          const propertyTicker = reservation && reservation.propertyTicker;

          if (reservation && reservation.multipleBookingId) {
            this.props.history.push(
              `/${propertyTicker}${locale}/${constants.STEP_PATHS.STEP_3}/${reservation.multipleBookingId}${query}`
            );
          } else {
            this.props.history.push(
              `/${propertyTicker}${locale}/${constants.STEP_PATHS.STEP_1}${query}`
            );
          }
        })
        .catch(err => {
          console.log("ERROR");
          console.log(err);
        });
    }
  }

  render() {
    return null;
  }
}

RecoverReservation.propTypes = {
  params: PropTypes.object,
  push: PropTypes.func,
  changeConfiguration: PropTypes.func,
  location: PropTypes.object,
};

export default withRouter(RecoverReservation);
